import {
  getCategoryTotals,
  getTotals,
} from '@macmillan-learning/gradebook-shared';
import { useEffect } from 'react';

import { filterAssignments } from '../../../../actions/filter';
import { SEARCH_TYPES } from '../../../../utils/constants';
import { useIsgStore } from '../store';

function useAssignments({
  searchTerm = '',
  gradebookData,
  categories,
  weights,
  settings,
}) {
  const [state, dispatch] = useIsgStore();
  useEffect(() => {
    if (searchTerm !== '') {
      const filteredCategoriesData = gradebookData.categoriesData.map(
        (category) => {
          const options = {
            searchType: SEARCH_TYPES.ASSIGNMENTS,
            search: searchTerm,
          };

          const filteredCategory = {
            ...category,
            assignments: filterAssignments(category.assignments, options),
            unfilteredAssignments: category.assignments,
          };

          const total = getCategoryTotals({
            category: filteredCategory,
            weights,
            settings,
            categories,
          });

          return {
            ...filteredCategory,
            total,
          };
        },
      );

      const filteredAssignmentsList = filteredCategoriesData.flatMap(
        ({ assignments }) => assignments,
      );
      const courseTotals = getTotals(
        filteredAssignmentsList,
        weights,
        settings,
        categories,
      );
      dispatch({
        categoriesData: filteredCategoriesData,
        course: {
          ...gradebookData.course,
          ...courseTotals,
        },
      });
    } else {
      dispatch(gradebookData);
    }
  }, [categories, dispatch, gradebookData, searchTerm, settings, weights]);

  return state;
}

export { useAssignments };
